// extracted by mini-css-extract-plugin
export var active = "_hv-2";
export var recordingDot = "_hv-1";
export var recordingIndicator = "_hv-0";